/**
 * IVG Pro — High-Performance Theme Interactivity
 */

function initAll() {
  initMobileMenu();
  initWishlistDrawer();
  initCartDrawer();
  initCountdownTimer();
  initWishlistToggle();
  initAjaxAddToCart();
  initWishlistPageDelegation(); // Fix: separated from saveWishlist() to prevent duplicate listeners
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

/* ── Money Formatter Helper ────────────────────────────────────────────────── */
function formatMoney(cents) {
  if (cents === null || cents === undefined) return '£0';
  if (typeof cents === 'string') return cents;
  const pounds = Math.floor(cents / 100);
  return '£' + pounds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* ── 1. Mobile Menu ───────────────────────────────────────────────────────── */
function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-menu-drawer]');
  const closeBtns = document.querySelectorAll('[data-menu-close]');

  if (!toggle || !drawer) return;

  toggle.addEventListener('click', () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });
}

/* ── 2. Wishlist Drawer & LocalStorage Manager ───────────────────────────── */
function getWishlist() {
  try {
    const raw = localStorage.getItem('ivgpro_wishlist');
    const parsed = raw ? JSON.parse(raw) : [];
    // Normalize to objects
    return parsed.map(item => {
      if (typeof item === 'string' || typeof item === 'number') {
        return { id: String(item), title: 'Saved Product', price: '', image: '', variant_id: '', url: '#' };
      }
      return item;
    });
  } catch (e) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem('ivgpro_wishlist', JSON.stringify(items));
  updateWishlistUI();
  // NOTE: WishlistPage click delegation is now in initWishlistPageDelegation()
  // and registered only once at DOMContentLoaded — not here.
}

/* ── Wishlist Page Delegation (registered once at init) ───────────────────── */
function initWishlistPageDelegation() {
  const wishlistPageGrid = document.getElementById('WishlistPageGrid');
  if (!wishlistPageGrid) return;

  wishlistPageGrid.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-wishlist-add-cart]');
    if (addBtn) {
      const variantId = addBtn.dataset.wishlistAddCart;
      if (!variantId) return;

      addBtn.disabled = true;
      const originalHTML = addBtn.innerHTML;
      addBtn.innerHTML = 'Adding...';

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => res.json())
      .then(() => {
        addBtn.innerHTML = 'Added!'; addBtn.classList.add('is-added');
        setTimeout(() => {
          addBtn.disabled = false;
          addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
        }, 1500);

        fetchAndRenderCart(true);
      })
      .catch(err => {
        console.error(err);
        addBtn.disabled = false;
        addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
      });
    }

    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      const idToRemove = removeBtn.dataset.wishlistRemove;
      let wishlist = getWishlist();
      wishlist = wishlist.filter(i => String(i.id) !== String(idToRemove));
      saveWishlist(wishlist);
    }
  });
}

function updateWishlistUI() {
  const wishlist = getWishlist();
  
  // Update all wishlist count badges
  const countBadges = document.querySelectorAll('[data-wishlist-count], [data-wishlist-drawer-count]');
  countBadges.forEach(badge => {
    badge.textContent = wishlist.length;
  });

  // Highlight heart buttons on page
  const wishlistBtns = document.querySelectorAll('.product-card__wishlist');
  wishlistBtns.forEach(btn => {
    const pId = btn.dataset.productId;
    if (pId && wishlist.some(i => String(i.id) === String(pId))) {
      btn.classList.add('is-active');
      btn.style.color = '#054bff';
    } else {
      btn.classList.remove('is-active');
      btn.style.color = '#CCCCCC';
    }
  });

  // Re-render drawer content if container exists
  renderWishlistDrawer();
  renderWishlistPage();
}


function renderWishlistPage() {
  const container = document.getElementById('WishlistPageGrid');
  if (!container) return;

  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 40px 0;">
        <h3 style="font-size:18px; margin-bottom:8px;">Your wishlist is currently empty.</h3>
        <p style="color:#666; margin-bottom: 24px;">Find something you love and save it here.</p>
        <a href="/collections/all" class="btn btn-accent" style="display:inline-block; padding: 12px 24px; text-decoration:none; color:#fff; border-radius:8px;">Continue Shopping</a>
      </div>
    `;
    return;
  }

  let html = '';
  wishlist.forEach(item => {
    const imgMarkup = item.image 
      ? `<img src="${item.image}" alt="${item.title}">`
      : `<div style="height:180px; display:flex; align-items:center; justify-content:center; background:#f9f9f9; margin-bottom:16px; border-radius:8px;"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>`;

    html += `
      <div class="wishlist-page-item" data-wishlist-id="${item.id}">
        <button type="button" class="remove-btn" data-wishlist-remove="${item.id}" aria-label="Remove item">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <a href="${item.url || '#'}" style="text-decoration:none;">
          ${imgMarkup}
          <h4>${item.title || 'Product'}</h4>
        </a>
        <div class="price">${item.price || ''}</div>
        ${item.variant_id ? `
          <button type="button" class="btn btn-accent" data-wishlist-add-cart="${item.variant_id}" style="background:#111; color:#fff; border:none;">
            Add to Bag
          </button>
        ` : ''}
      </div>
    `;
  });

  container.innerHTML = html;
}

function renderWishlistDrawer() {
  const container = document.querySelector('[data-wishlist-items-container]');
  if (!container) return;

  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="drawer__empty-state">
        <div class="empty-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>
        <h3>Your wishlist is empty</h3>
        <p>Save items you love to find them easily later!</p>
        <a href="/collections/all" class="btn btn-accent btn-full" style="margin-top: 16px;">Explore Products</a>
      </div>
    `;
    return;
  }

  let html = '';
  wishlist.forEach(item => {
    const imgMarkup = item.image 
      ? `<img src="${item.image}" alt="${item.title}" class="wishlist-drawer-item__image">`
      : `<span style="font-size:24px;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span>`;

    html += `
      <div class="wishlist-drawer-item" data-wishlist-id="${item.id}">
        <a href="${item.url || '#'}" class="wishlist-drawer-item__image-wrap">
          ${imgMarkup}
        </a>
        <div class="wishlist-drawer-item__info">
          <a href="${item.url || '#'}" class="wishlist-drawer-item__title">${item.title || 'Product'}</a>
          <div class="wishlist-drawer-item__price">${item.price || ''}</div>
          <div class="wishlist-drawer-item__actions">
            ${item.variant_id ? `
              <button type="button" class="btn btn-accent wishlist-drawer-item__add-btn" data-wishlist-add-cart="${item.variant_id}">
                Add to Bag
              </button>
            ` : ''}
            <button type="button" class="wishlist-drawer-item__remove-btn" data-wishlist-remove="${item.id}">
              Remove
            </button>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
}

function initWishlistDrawer() {
  const triggers = document.querySelectorAll('[data-wishlist-drawer-toggle]');
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const closeBtns = document.querySelectorAll('[data-wishlist-drawer-close]');

  if (drawer) {
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        renderWishlistDrawer();
  renderWishlistPage();
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Wishlist Drawer Delegation (Add to Bag & Remove)
    drawer.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addBtn) {
        const variantId = addBtn.dataset.wishlistAddCart;
        if (!variantId) return;

        addBtn.disabled = true;
        addBtn.innerHTML = 'Adding...';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(() => {
          addBtn.textContent = '✓ Added!';
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Bag';
          }, 1500);

          // Close wishlist drawer and open cart drawer
          drawer.classList.remove('is-open');
          fetchAndRenderCart(true);
        })
        .catch(err => {
          console.error('Wishlist add to cart error:', err);
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Bag';
        });
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const idToRemove = removeBtn.dataset.wishlistRemove;
        let wishlist = getWishlist();
        wishlist = wishlist.filter(i => String(i.id) !== String(idToRemove));
        saveWishlist(wishlist);
      }
    });
  }

}

function initWishlistToggle() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;
    e.preventDefault();

    const productId = btn.dataset.productId;
    const productTitle = btn.dataset.productTitle || 'Product';
    const productPrice = btn.dataset.productPrice || '';
    const productImage = btn.dataset.productImage || '';
    const productUrl = btn.dataset.productUrl || '#';
    const variantId = btn.dataset.variantId || '';

    let wishlist = getWishlist();
    const idx = wishlist.findIndex(i => String(i.id) === String(productId));

    if (idx > -1) {
      wishlist.splice(idx, 1);
    } else {
      wishlist.push({ id: productId, title: productTitle, price: productPrice, image: productImage, url: productUrl, variant_id: variantId });
    }
    saveWishlist(wishlist);
  });

  updateWishlistUI();
}

/* ── 3. Cart Drawer ──────────────────────────────────────────────────────── */
function fetchAndRenderCart(openDrawer = false) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
      if (openDrawer) {
        const cartDrawer = document.querySelector('[data-cart-drawer]');
        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      }
    });
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
  });
}

function renderCartDrawer(cart) {
  const container = document.querySelector('[data-cart-items-container]');
  const subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (!container) return;

  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  if (cart.items.length === 0) {
    container.innerHTML = `
      <div class="drawer__empty-state">
        <div class="empty-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></div>
        <h3>Your cart is empty</h3>
        <p>Looks like you haven't added anything yet.</p>
        <a href="/collections/all" class="btn btn-accent btn-full" style="margin-top: 16px;">Start Shopping</a>
      </div>
    `;
    return;
  }

  let html = '';
  cart.items.forEach(item => {
    const imgMarkup = item.image
      ? `<img src="${item.image}" alt="${item.title}" class="cart-drawer-item__image">`
      : `<span style="font-size:24px;">📦</span>`;

    html += `
      <div class="cart-drawer-item" data-cart-key="${item.key}">
        <a href="${item.url}" class="cart-drawer-item__image-wrap">
          ${imgMarkup}
        </a>
        <div class="cart-drawer-item__info">
          <a href="${item.url}" class="cart-drawer-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-drawer-item__price">${formatMoney(item.price)}</div>
          <div class="cart-drawer-item__qty-row">
            <button type="button" class="qty-btn" data-cart-decrease="${item.key}" aria-label="Decrease quantity">−</button>
            <span class="qty-display">${item.quantity}</span>
            <button type="button" class="qty-btn" data-cart-increase="${item.key}" aria-label="Increase quantity">+</button>
            <button type="button" class="cart-remove-btn" data-cart-remove="${item.key}" aria-label="Remove item">Remove</button>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
}

function initCartDrawer() {
  const triggers = document.querySelectorAll('[data-cart-drawer-toggle]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');

  if (drawer) {
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        fetchAndRenderCart(true);
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Cart drawer event delegation
    drawer.addEventListener('click', (e) => {
      const decreaseBtn = e.target.closest('[data-cart-decrease]');
      if (decreaseBtn) {
        const key = decreaseBtn.dataset.cartDecrease;
        const qtyEl = decreaseBtn.nextElementSibling;
        const currentQty = parseInt(qtyEl.textContent);
        if (currentQty <= 1) {
          updateCartItem(key, 0);
        } else {
          updateCartItem(key, currentQty - 1);
        }
      }

      const increaseBtn = e.target.closest('[data-cart-increase]');
      if (increaseBtn) {
        const key = increaseBtn.dataset.cartIncrease;
        const qtyEl = increaseBtn.previousElementSibling;
        const currentQty = parseInt(qtyEl.textContent);
        updateCartItem(key, currentQty + 1);
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const key = removeBtn.dataset.cartRemove;
        updateCartItem(key, 0);
      }
    });
  }

  fetchAndRenderCart();
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity })
  })
  .then(res => res.json())
  .then(cart => {
    renderCartDrawer(cart);
    updateCartCount(cart.item_count);
  });
}

/* ── 4. Ajax Add to Cart ─────────────────────────────────────────────────── */
function initAjaxAddToCart() {
  const form = document.getElementById('AddToCartForm');
  if (!form) return;

  const submitBtn = form.querySelector('[data-add-to-cart-btn]');

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
    }

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.json())
    .then(item => {
      if (item.status === 422) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = 'Add to Bag'; }
        return;
      }
      if (submitBtn) {
        submitBtn.innerHTML = '✓ Added!';
        submitBtn.classList.add('is-added');
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Add to Bag';
          submitBtn.classList.remove('is-added');
        }, 1500);
      }
      fetchAndRenderCart(true);
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = 'Add to Bag'; }
    });
  });

  // Compatible product add
  window.addCompatibleToCart = function() {
    const select = document.getElementById('comp_variant_id');
    if (!select) return;
    const variantId = select.value;
    if (!variantId) return;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.json())
    .then(() => fetchAndRenderCart(true))
    .catch(err => console.error('Compatible add to cart error:', err));
  };
}

/* ── 5. Countdown Timer ──────────────────────────────────────────────────── */
function initCountdownTimer() {
  const timerEl = document.querySelector('[data-countdown]');
  if (!timerEl) return;

  function tick() {
    const now = new Date();
    const end = new Date();
    end.setHours(17, 0, 0, 0);
    if (now > end) end.setDate(end.getDate() + 1);
    const diff = end - now;
    if (diff <= 0) { timerEl.textContent = '00:00:00'; return; }
    const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    timerEl.textContent = `${h}:${m}:${s}`;
  }

  tick();
  setInterval(tick, 1000);
}

/* ── 6. Variant Selector ─────────────────────────────────────────────────── */
document.addEventListener('click', (e) => {
  // Open/close custom select
  const trigger = e.target.closest('.custom-select-trigger');
  if (trigger) {
    const wrapper = trigger.closest('.custom-select-wrapper');
    const isOpen = wrapper.classList.contains('is-open');
    document.querySelectorAll('.custom-select-wrapper.is-open').forEach(w => w.classList.remove('is-open'));
    if (!isOpen) wrapper.classList.add('is-open');
    return;
  }

  // Select an option
  const option = e.target.closest('.custom-select-option');
  if (option) {
    const wrapper = option.closest('.custom-select-wrapper');
    const optionIndex = parseInt(wrapper.dataset.optionIndex);
    const value = option.dataset.value;

    // Update trigger display
    wrapper.querySelector('.custom-select-value').textContent = value;
    wrapper.querySelectorAll('.custom-select-option').forEach(o => o.classList.remove('is-selected'));
    option.classList.add('is-selected');
    wrapper.classList.remove('is-open');

    // Update hidden input
    const group = wrapper.closest('.variant-option-group');
    if (group) {
      const hiddenInput = group.querySelector('.hidden-option-input');
      if (hiddenInput) hiddenInput.value = value;
    }

    // Trigger variant change
    updateVariant();
    return;
  }

  // Close selects when clicking outside
  if (!e.target.closest('.custom-select-wrapper')) {
    document.querySelectorAll('.custom-select-wrapper.is-open').forEach(w => w.classList.remove('is-open'));
  }
});

function updateVariant() {
  const form = document.getElementById('AddToCartForm');
  if (!form) return;

  // Build selected options array
  const optionGroups = form.querySelectorAll('.variant-option-group');
  const selectedOptions = [];
  optionGroups.forEach(group => {
    const hiddenInput = group.querySelector('.hidden-option-input');
    if (hiddenInput) selectedOptions.push(hiddenInput.value);
  });

  // Find matching variant from Shopify product JSON
  const productDataEl = document.getElementById('ProductJSON');
  if (!productDataEl) return;

  let productData;
  try { productData = JSON.parse(productDataEl.textContent); } catch(e) { return; }

  const matchedVariant = productData.variants.find(v => {
    return v.options.every((opt, idx) => opt === selectedOptions[idx]);
  });

  if (!matchedVariant) return;

  // Update form ID
  const idInput = form.querySelector('input[name="id"]');
  if (idInput) idInput.value = matchedVariant.id;

  // Update price display
  const priceEl = document.getElementById('display-net-price');
  if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price);

  // Update add to cart button
  const addBtn = form.querySelector('[data-add-to-cart-btn]');
  if (addBtn) {
    if (matchedVariant.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Bag';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Out of Stock';
    }
  }

  // Update stock indicator
  const stockEl = document.querySelector('[data-stock-status]');
  if (stockEl) {
    if (matchedVariant.available) {
      stockEl.textContent = 'In Stock - Dispatch Today';
      stockEl.style.color = '#059669';
    } else {
      stockEl.textContent = 'Out of Stock';
      stockEl.style.color = '#DC2626';
    }
  }
}
